module.exports = __webpack_public_path__ + "static/media/doc.254ef210.svg";